"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _reactUseKeypress = _interopRequireDefault(require("react-use-keypress"));

var _router = require("@reach/router");

var _EditorWrapper = _interopRequireDefault(require("./EditorWrapper"));

var _Loader = _interopRequireDefault(require("../Loader"));

var _Sidebar = _interopRequireDefault(require("./Sidebar"));

var _Editor = _interopRequireDefault(require("./Editor"));

var _utils = require("../../utils");

var _routes = _interopRequireDefault(require("../../routes"));

var _redux = require("../../redux");

var _templateObject;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
} // We need to store the post ID so we can remove the lock when navigating to a different page (old ID won't be available anymore)


var postLockID = null;

var AdminEditor = function AdminEditor(props) {
  var _site$editorOptions, _site$editorOptions$s, _post$locked2, _site$editorOptions2, _site$editorOptions3, _site$editorOptions3$, _site$editorOptions4, _site$editorOptions4$;

  var fields = props.fields,
      defaultComponent = props.defaultComponent;

  var _ref4 = (0, _redux.useAppSelector)(function (state) {
    return state;
  }),
      editorSettings = _ref4.ui.editorSettings,
      _ref4$cms = _ref4.cms,
      site = _ref4$cms.site,
      siteLoaded = _ref4$cms.siteLoaded,
      post = _ref4$cms.editor.post;

  var dispatch = (0, _redux.useAppDispatch)();
  var postID = (0, _react.useMemo)(function () {
    return (0, _utils.getPostID)(site);
  }, [siteLoaded, window.location.pathname]); // Timer for lock check

  var _ref5 = (0, _react.useState)(0),
      _ref6 = _slicedToArray(_ref5, 2),
      postLockTimer = _ref6[0],
      setPostLockTimer = _ref6[1]; // Determine if sidebar should be open on default when visiting the editor


  var _ref7 = (0, _react.useState)(!!(site !== null && site !== void 0 && (_site$editorOptions = site.editorOptions) !== null && _site$editorOptions !== void 0 && (_site$editorOptions$s = _site$editorOptions.sidebar) !== null && _site$editorOptions$s !== void 0 && _site$editorOptions$s.defaultOpen)),
      _ref8 = _slicedToArray(_ref7, 2),
      sidebarActive = _ref8[0],
      setSidebarActive = _ref8[1];

  var template = (0, _utils.getTemplateByPost)(post, fields);
  var Component = template === null || template === void 0 ? void 0 : template.component;
  var postLoaded = postID && (post === null || post === void 0 ? void 0 : post.id) === postID; // For the post lock functionality we need 4 useEffect functions to cover the whole process
  // 1. Set up interval function on initial load and remove post lock in case user leaves the editor
  // 2. Refresh the lock status every couple of seconds or check if post is still locked
  // 3. Inform user who is currently editing the post by displaying the take over dialog
  // 4. Remove lock status from old post in case user navigates away via editor link

  (0, _react.useEffect)(function () {
    // Activate postLockTimer for post locking
    var intervalID = setInterval(function () {
      setPostLockTimer(function (time) {
        return time + 1;
      });
    }, 60000); // 60 seconds

    return function () {
      clearInterval(intervalID);

      if (postLoaded && !(post !== null && post !== void 0 && post.locked)) {
        // Remove post lock once we leave the post editor
        removePostLock(postID);
      }
    };
  }, []);
  (0, _react.useEffect)(function () {
    // Skip initial fetch (postLockTimer = 0) because we're already setting the status on initial getPost fetch in WP
    if (postLoaded && postLockTimer) {
      if (post !== null && post !== void 0 && post.locked) {
        // Fetch post again in case it's locked to determine if other user is still editing
        loadPost();
      } else {
        // Refresh the post lock status to inform WordPress that we are still editing
        refreshPostLock();
      }
    }
  }, [postLockTimer]);
  (0, _react.useEffect)(function () {
    // Remove previous post ID in case user navigates to a different page
    if (postLockID) {
      removePostLock(postLockID);
    } // Set new post id


    postLockID = postID;
  }, [postID]);
  (0, _react.useEffect)(function () {
    var _post$locked;

    if (post !== null && post !== void 0 && (_post$locked = post.locked) !== null && _post$locked !== void 0 && _post$locked.id) {
      handleOpenTakeOverDialog();
    }
  }, [post === null || post === void 0 ? void 0 : (_post$locked2 = post.locked) === null || _post$locked2 === void 0 ? void 0 : _post$locked2.id]);
  (0, _react.useEffect)(function () {
    if (postID > 0) {
      loadPost(); // Add fresh copy of editor to state

      dispatch(_redux.cmsActions.addEditorSite(site));
    }

    return function () {
      return dispatch(_redux.cmsActions.clearEditor());
    };
  }, [postID]);
  (0, _reactUseKeypress.default)('Escape', function () {
    !editorSettings.fullscreen && setSidebarActive(!sidebarActive);
  });

  var loadPost = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch(_redux.postActions.getPost({
                id: postID
              }));

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function loadPost() {
      return _ref9.apply(this, arguments);
    };
  }();

  var handleTakeOver = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return dispatch(_redux.postActions.takeOverPost({
                id: postID
              }));

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleTakeOver() {
      return _ref10.apply(this, arguments);
    };
  }();

  var refreshPostLock = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return dispatch(_redux.postActions.refreshPostLock({
                id: postID
              }));

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function refreshPostLock() {
      return _ref11.apply(this, arguments);
    };
  }();

  var removePostLock = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return dispatch(_redux.postActions.removePostLock({
                id: id
              }));

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function removePostLock(_x) {
      return _ref12.apply(this, arguments);
    };
  }();

  var handleOpenTakeOverDialog = function handleOpenTakeOverDialog() {
    var _post$locked3;

    dispatch(_redux.uiActions.showDialog({
      open: true,
      title: 'Locked',
      component: /*#__PURE__*/_react.default.createElement(_antd.Space, {
        direction: "vertical",
        size: 20
      }, /*#__PURE__*/_react.default.createElement(_antd.Typography.Text, null, "This content is currently locked. If you take over, ", post === null || post === void 0 ? void 0 : (_post$locked3 = post.locked) === null || _post$locked3 === void 0 ? void 0 : _post$locked3.email, " will be blocked from continuing to edit."), /*#__PURE__*/_react.default.createElement(_antd.Space, null, /*#__PURE__*/_react.default.createElement(_antd.Button, {
        onClick: function onClick() {
          dispatch(_redux.uiActions.hideDialog());
          (0, _router.navigate)((0, _routes.default)("collection", {
            postTypeID: (post === null || post === void 0 ? void 0 : post.postTypeID) || 'page'
          }));
        },
        children: "Dashboard"
      }), /*#__PURE__*/_react.default.createElement(_antd.Button, {
        onClick: function onClick() {
          return dispatch(_redux.uiActions.hideDialog());
        },
        children: "Preview"
      }), /*#__PURE__*/_react.default.createElement(_antd.Button, {
        onClick: handleTakeOver,
        type: "primary",
        children: "Take Over"
      })))
    }));
  };

  var handleToggleSidebar = function handleToggleSidebar() {
    if (sidebarActive) {
      _antd.message.info({
        content: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Press ", /*#__PURE__*/_react.default.createElement(_antd.Typography.Text, {
          keyboard: true
        }, "ESC"), " to reopen sidebar")
      });
    }

    setSidebarActive(!sidebarActive);
  };

  if (!postID) {
    return defaultComponent;
  }

  var sidebarOptions = _objectSpread(_objectSpread({}, site === null || site === void 0 ? void 0 : (_site$editorOptions2 = site.editorOptions) === null || _site$editorOptions2 === void 0 ? void 0 : _site$editorOptions2.sidebar), {}, {
    active: sidebarActive
  });

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_EditorWrapper.default, {
    sidebarOptions: sidebarOptions,
    loaded: postLoaded,
    locked: !!(post !== null && post !== void 0 && post.locked)
  }, postLoaded ? /*#__PURE__*/_react.default.createElement(_Editor.default, (0, _extends2.default)({
    fields: fields,
    postID: postID
  }, props, {
    sidebarOptions: sidebarOptions
  })) : /*#__PURE__*/_react.default.createElement(_Loader.default, null)), postLoaded && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, post !== null && post !== void 0 && post.locked ? /*#__PURE__*/_react.default.createElement(FloatingButton, {
    sidebarPosition: site === null || site === void 0 ? void 0 : (_site$editorOptions3 = site.editorOptions) === null || _site$editorOptions3 === void 0 ? void 0 : (_site$editorOptions3$ = _site$editorOptions3.sidebar) === null || _site$editorOptions3$ === void 0 ? void 0 : _site$editorOptions3$.position
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.LockOutlined, null),
    onClick: handleOpenTakeOverDialog,
    size: "large",
    type: "primary"
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, sidebarActive ? /*#__PURE__*/_react.default.createElement(_Sidebar.default, {
    className: "jam-cms",
    fields: fields,
    editable: !!Component,
    sidebarOptions: sidebarOptions,
    onToggleSidebar: handleToggleSidebar
  }) : /*#__PURE__*/_react.default.createElement(FloatingButton, {
    sidebarPosition: site === null || site === void 0 ? void 0 : (_site$editorOptions4 = site.editorOptions) === null || _site$editorOptions4 === void 0 ? void 0 : (_site$editorOptions4$ = _site$editorOptions4.sidebar) === null || _site$editorOptions4$ === void 0 ? void 0 : _site$editorOptions4$.position
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.EditOutlined, null),
    onClick: handleToggleSidebar,
    size: "large",
    type: "primary"
  })))));
};

var FloatingButton = (0, _styledComponents.default)('div')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  position: fixed;\n  left: ", ";\n  right: ", ";\n  bottom: 200px;\n  z-index: 99999;\n\n  .ant-btn-icon-only.ant-btn-lg {\n    border-radius: ", ";\n  }\n"])), function (_ref) {
  var sidebarPosition = _ref.sidebarPosition;
  return sidebarPosition === 'left' ? 0 : 'unset';
}, function (_ref2) {
  var sidebarPosition = _ref2.sidebarPosition;
  return sidebarPosition === 'left' ? 'unset' : 0;
}, function (_ref3) {
  var sidebarPosition = _ref3.sidebarPosition;
  return sidebarPosition === 'left' ? '0 2px 2px 0' : '2px 0 0 2px';
});
var _default = AdminEditor;
exports.default = _default;